class AccordionHeaderComponent {
  constructor() {
    Object.assign(this, {
      accordionCtrl: null,
      accordionPaneCtrl: null,
    });
  }

  togglePane() {
    this.accordionCtrl.select(this.accordionPaneCtrl);
  }
}

angular.module('pims')
  .component('accordionHeader', {
    transclude: true,
    templateUrl: 'app/components/accordion/header/accordion-header.component.html',
    controller: AccordionHeaderComponent,
    controllerAs: 'vm',
    bindings: {
    },
    require: {
      accordionCtrl: '^accordion',
      accordionPaneCtrl: '^accordionPane'
    },
  });
